module.exports = __webpack_public_path__ + "img/missionimpokikible.c042002e.png";